import * as React from 'react';

function switchClass(index, length) {
    if (index === 0) {
        return "border-l rounded-l-xl";
    }
    if (index === length - 1) {
        return "rounded-r-xl";
    }
    return "";
}
function ButtonGroup(props) {
    const { data, onSelection, selected, className } = props;
    return (React.createElement("ul", { className: `flex flex-row justify-center my-8 ${className}` }, Object.keys(data).map((key, index, { length }) => (React.createElement("li", { key: key, className: `w-40 border-y border-r border-slate-400 text-center text-xl ${switchClass(index, length)} ${key === selected ? "bg-blue-700 text-white" : ""}` },
        React.createElement("a", { href: `#skills-${key}`, onClick: () => onSelection(key) }, data[key].display))))));
}

export { ButtonGroup };
//# sourceMappingURL=ButtonGroup.js.map
